import React from 'react';

import "./Disclosure.css"

const Disclosure = (props) => (
	<div className={"purchase-text"}>
		<br />
		<div className={"purchase-header"}>
			<p className={"purchase-aggregate-header"}>SAR SCA Database Access Request </p>
		</div>

		<div className={"purchase-body"}>
			<div className={"purchase-section"}>
				<div>
					Thank you for your interest in the SAR SCA Database to evaluate potential severity of filed securities class actions. Your login credentials are not currently registered with an active SCA Database license. Please contact us at info@sarlit.com or call 202.436.9994 to learn more about licensing SAR SCA Data for your organization.

				</div>
			</div>
		</div>
		<br />
	</div>
);


export default Disclosure;



// WEBPACK FOOTER //
// ./src/components/CaseSelector/Disclosure.js